import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { aboutData } from '../mockData';
import { siteConfigAPI } from '../services/api';
import { Button } from './ui/button';
import { SITE_LOGO_PATH } from '../config/brand';

const AboutSection = () => {
  const [content, setContent] = useState(aboutData.content);

  useEffect(() => {
    siteConfigAPI
      .get()
      .then((config) => {
        if (config?.about_content?.length) setContent(config.about_content);
      })
      .catch(() => {});
  }, []);

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-red-700 mb-2">
                {aboutData.title}
              </h2>
              <div className="w-20 h-1 bg-red-700 mb-6"></div>
            </div>

            <div className="space-y-4">
              {content.map((paragraph, index) => (
                <p key={`about-p-${index}`} className="text-gray-700 text-base md:text-lg leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            <Button asChild className="bg-red-700 hover:bg-red-800 text-white font-semibold px-8 py-3 rounded transition-all duration-300 hover:scale-105 mt-6">
              <Link to={aboutData.buttonLink}>
                {aboutData.buttonText}
              </Link>
            </Button>
          </div>

          <div className="flex items-center justify-center">
            <img
              src={SITE_LOGO_PATH}
              alt="Swaarnim Book of Records logo"
              className="w-full max-w-md object-contain animate-float"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
